// IMPORT
import React from "react";

// CSS
import './SolutionHrP.css';

// Graphics
import Graphic from '../global/graphics/Img_Personal-Dienstplanung.svg'

// Components
import CompHeading from '../../components/CompHeading'
import CompPictureText from "../../components/CompPictureText";

// SolutionHrP
export default function SolutionHrP() {
  return (
    <div className="SolutionHrP-Content page-gap">
      <CompHeading
        Title={"Human Resource Planning (HRP)"}
        Subheading={"Komplexe Dienstplanung mit KI im Griff behalten."}
      />
      <CompPictureText
        Title={"KI-gestützte Personalplanung"}
        Subheading={""}
        Text={"Komplexe Dienstplanung, Personalengpässe und -überhänge zählen zu den drängendsten Problemen in jedem Unternehmen. " + 
          "Fachkräftemangel, steigende Fehlzeiten und kurzfristige Personalausfälle machen eine verlässliche Personalplanung schwer. " + 
          "Reaktive Planänderungen führen zu Überlastung der Teams und teils auch zu teuren Zeitarbeitskräften."}
        Graphic={Graphic}
        GraphicAlt={"KI-gestützte Personalplanung"}
      />
    </div>
  )
}
